export default __webpack_public_path__ + "static/media/FGlogo.75b24643.svg";